import React from 'react';
import {
    BadgeCheck,
    BrainCircuit,
    BriefcaseBusiness,
    Database,
    Layers3,
    LineChart,
    ShieldCheck,
    Sparkles,
    Waypoints
} from 'lucide-react';
import {FeatureItem} from '../../pages/site/site.types';
import styles from './styles/FeatureGrid.module.css';

interface FeatureGridProps {
    items: FeatureItem[];
    columns?: 3 | 4;
}

const defaultIcons = [
    BrainCircuit,
    LineChart,
    ShieldCheck,
    Layers3,
    Sparkles,
    Waypoints,
    BadgeCheck,
    BriefcaseBusiness
];

const namedIcons: Record<string, React.ElementType> = {
    brain: BrainCircuit,
    chart: LineChart,
    shield: ShieldCheck,
    layers: Layers3,
    sparkles: Sparkles,
    waypoints: Waypoints,
    badge: BadgeCheck,
    briefcase: BriefcaseBusiness,
    database: Database,
};

const FeatureGrid: React.FC<FeatureGridProps> = ({items, columns = 3}) => {
    return (
        <div
            className={styles.grid}
            style={{gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))`}}
        >
            {items.map((item, index) => {
                const Icon = item.iconName && namedIcons[item.iconName]
                    ? namedIcons[item.iconName]
                    : defaultIcons[index % defaultIcons.length];
                return (
                    <article className={`site-card ${styles.card}`} key={item.title}>
                        <div className={styles.iconWrap}>
                            <Icon size={18}/>
                        </div>
                        <h3 className={styles.title}>{item.title}</h3>
                        <p className={styles.description}>{item.description}</p>
                        <div className={styles.tags}>
                            {item.tags.map(tag => (
                                <span className="site-chip" key={tag}>{tag}</span>
                            ))}
                        </div>
                    </article>
                );
            })}
        </div>
    );
};

export default FeatureGrid;
